export const PERIODS = {
  wholePeriod: 'wholePeriod',
  lastDay: 'lastDay',
};

export const DEFAULT_DATA = 'cases';
export const ALL_HISTORY = 'all';
export const PER_100_THOUSANDS = 100000;

export const NOTIFY_TYPES = {
  error: 'danger',
  primary: 'primary',
  secondary: 'secondary',
  success: 'success',
  warning: 'warning',
  info: 'info',
  dark: 'dark',
  light: 'light',
};

export const TODAY = {
  cases: 'todayCases',
  deaths: 'todayDeaths',
  recovered: 'todayRecovered',
};

export const DEFAULT_ZOOM = 3;
export const COUNTRY_ZOOM = 4;

export const DEFAULT_LAT = 60;
export const DEFAULT_LONG = 100;

export const FIRST_DIVISION = 10 / 100;
export const SECOND_DIVISION = 50 / 100;

export const COLORS = { low: '#ffae00', medium: '#ff6600', hight: '#ff1e00' };

export const MAPBOX_STYLE = 'mapbox://styles/sizaya/ckireok4h7hjv17nrqcxeyzkc';
export const MAPBOX_KEY = 'pk.eyJ1Ijoic2l6YXlhIiwiYSI6ImNraW4zMGk2aDB6Y2kzMnFqM3k3dHd1cTEifQ.C4b5ctgb9K4koJwzcTycZw';

export const KEYBOARD_URL = '/virtual-keyboard/index.js';

export const LANGUAGES = { en: 'English', ru: 'Русский' };
